export default __webpack_public_path__ + "static/media/olle-maria.0c461a43.jpeg";